import { ChangeDirection } from "~tailwindui/types/enums"

export default (change: number): ChangeDirection => {
  if (change < 0) return ChangeDirection.Decrease
  if (change > 0) return ChangeDirection.Increase
  else return ChangeDirection.Constant
}
